<app-img-readonly-header
  *ngIf="financialSetupCreationDto"
  title="Paquetes financieros"
  alt="Daimler Truck"
  hasSubTitle="true"
  [subTitle]="financialSetupCreationDto && financialSetupCreationDto.financialSetupName ?? 'Nombre no disponible'"
  [version]="version"
  [status]="financialSetupCreationDto.status"
  image="/assets/images/cotizador/intro.jpg"
>
</app-img-readonly-header>
<app-preloader *ngIf="isLoading"></app-preloader>
<main *ngIf="!isLoading" class="main" id="">
  <div id="detail">
    <div class="pageWidth">
      <form [formGroup]="form">
        <app-general-information-form
          (financialSetupCreationChanges)="financialSetupCreationChanges($event)"
          (classificationChange)="onClassificationChange($event)"
          [financialSetupCreationDto]="financialSetupCreationDto"
          [isReadyToEdit]="isReadyToEdit"
          [financialConditions]="financialConditions"
          formControlName="generalInformation"
        ></app-general-information-form>

        <app-filters-form
          [classification]="classification"
          [financialSetupModels]="financialSetupModels"
          [dealerIds]="dealerIds"
          [financialSetupForm]="form"
          [standardFinancialSetupAttributes]="standardFinancialSetupAttributes"
          [isReadyToEdit]="isReadyToEdit"
          (modelSelectedEmit)="modelSelected($event)"
          (dealerSelectedEmit)="dealerSelected($event)"
          (standardFinancialSetupAttributesChange)="standardFinancialSetupAttributesChange($event)"
          formControlName="standardFinancialSetupAttributes"
        ></app-filters-form>
        <app-insurance-form
          [isReadyToEdit]="isReadyToEdit"
          (insuranceTypeChange)="insuranceTypeChange($event)"
          [insuranceType]="insuranceType"
          formControlName="insurance"
        ></app-insurance-form>
        <app-conditions
          [isReadyToEdit]="isReadyToEdit"
          (financialConditionsChange)="financialConditionsChange($event)"
          [financialConditions]="financialConditions"
          [financialSetup]="financialSetupCreationDto"
          [allowCapitalGrace]="allowCapitalGrace"
          [allowInterestGrace]="allowInterestGrace"
          formControlName="condition"
          (saveConditions)="changeCondition($event)"
        ></app-conditions>
      </form>
      <!-- MÓDULO INFORMACIÓN GENERAL EDITABLE -->

      <!--      <app-general-information-readonly
        *ngIf=""
      ></app-general-information-readonly>

      <app-filters-readonly *ngIf=""></app-filters-readonly>

      <app-insurance-readonly *ngIf=""></app-insurance-readonly>

      <app-condition-readonly *ngIf=""></app-condition-readonly>-->

      <!-- Acciones usuario Editor en páginas editables -->
      <div class="actions">
        <div class="wrapper">
          <button (click)="cancel()" type="button" class="secondary">
            Cancelar
          </button>
          <button
            [disabled]="form.invalid"
            type="submit"
            class="primary"
            (click)="save()"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
